module.exports = __webpack_public_path__ + "static/images/containers/ClanPanel/components/Item/images/icon-challenges.c7d0ec3d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ClanPanel/components/Item/images/icon-challenges.png
// module id = 3070
// module chunks = 11